'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Type = function () {
  function Type() {
    var types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, Type);

    this.types = types;
  }

  /**
   * Is defined
   * @returns {boolean}
   */


  _createClass(Type, [{
    key: 'addExample',


    /**
     * Add example
     * @param {Object} example
     * @param {string} [example.type]
     * @param {Object|Object[]} [example.params]
     * @param {Object} [example.param]
     * @param {string} [example.param.type]
     * @param {Object} [example.param.params]
     * @returns {string}
     */
    value: function addExample(example) {
      var type = getType(example);
      if (!type) return;
      if (!this.types.includes(type)) this.types.push(type);
      return type;
    }

    /**
     * To string
     * @returns {string}
     */

  }, {
    key: 'toString',
    value: function toString() {
      return '{' + this.types.join('|') + '}';
    }
  }, {
    key: 'isDefined',
    get: function get() {
      return !!this.types.length;
    }

    /**
     * Parse
     * @param {string} string
     * @returns {Type}
     */

  }], [{
    key: 'parse',
    value: function parse(string) {
      var types = string.trim().slice(1, -1).split('|').filter(function (type) {
        return type;
      });
      return new Type(types);
    }
  }]);

  return Type;
}();

var typeMap = {
  'String': 'string',
  'Function': 'function',
  'Boolean': 'boolean',
  'Number': 'number'

  /**
   * Get type
   * @param {Object} example
   * @param {string} [example.type]
   * @param {Object|Object[]} [example.params]
   * @param {Object} [example.param]
   * @param {string} [example.param.type]
   * @param {Object} [example.param.params]
   * @returns {string}
   */
};function getType(example) {
  if (example === null || example === undefined || !example.type) {
    return null;
  }
  if (example.type === 'Array') {
    if (example.params.length) {
      return getType(example.params[0]) + '[]';
    }
  }

  if (example.type === 'Promise') {
    return 'Promise<' + getType(example.param) + '>';
  }
  return typeMap[example.type] || example.type;
}

module.exports = Type;


//////////////////
// WEBPACK FOOTER
// ../lib/JSDoc/Type.js
// module id = 172
// module chunks = 0